export const toArray = (arg: string | string[]): string[] => (Array.isArray(arg) ? arg : [arg])
.filter((v) => !!v)
// replace &nbsp with regular spaces to prevent attribute values duplication during grouping
// eslint-disable-next-line no-irregular-whitespace
.map((v) => (v.replace !== undefined ? v.replace(/ /g, ' ') : v));
